const APP_MODES = {
  DISHES: 'DISHES',
  FULL: 'FULL',
  MINI: 'MINI',
  RESTAURANT: 'RESTAURANT',
};

export default APP_MODES;
